import { notificationTypes } from "./notificationTypes";

const init = {
  message: "",
  variant: "",
};

const notificationReducer = (state = init, action) => {
  switch (action.type) {
    case notificationTypes.NOTIFICATION:
      return action.payload;
    case notificationTypes.CLEAR_NOTIFICATION:
      return action.payload;
    default:
      return state;
  }
};

export default notificationReducer;
